export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        }
      },
      "ar-EG": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        }
      },
      "ar-SA": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        }
      },
      "el-GR": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        }
      },
      "el-CY": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        }
      },
      "de-DE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        }
      },
      "de-AT": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        }
      },
      "de-CH": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        }
      },
      "en-US": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a company"])}
        }
      },
      "en-GB": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a company"])}
        }
      },
      "it-IT": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona un'azienda"])}
        }
      },
      "fr-FR": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        }
      },
      "es-ES": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione una empresa"])}
        }
      },
      "pl-PL": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz firmę"])}
        }
      },
      "nl-NL": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecteer een bedrijf"])}
        }
      },
      "bg-BG": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Моля, изберете фирма"])}
        }
      },
      "bs-BA": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Molimo odaberite kompaniju"])}
        }
      },
      "da-DK": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vælg et firma"])}
        }
      },
      "et-EE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valige ettevõte"])}
        }
      },
      "fi-FI": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valitse yritys"])}
        }
      },
      "he-IL": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אנא בחר חברה"])}
        }
      },
      "ga-IE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnaigh cuideachta le do thoil"])}
        }
      },
      "ja-JP": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社を選択してください"])}
        }
      },
      "hr-HR": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odaberite tvrtku"])}
        }
      },
      "lv-LV": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lūdzu, izvēlieties uzņēmumu"])}
        }
      },
      "lt-LT": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkite įmonę"])}
        }
      },
      "pt-PT": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione uma empresa"])}
        }
      },
      "ro-RO": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vă rugăm să selectați o companie"])}
        }
      },
      "ru-RU": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, выберите компанию"])}
        }
      },
      "sv-SE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj ett företag"])}
        }
      },
      "sk-SK": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte spoločnosť"])}
        }
      },
      "cs-CZ": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte společnost"])}
        }
      },
      "hu-HU": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Válasszon egy vállalatot"])}
        }
      },
      "fr-BE": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        }
      },
      "fr-LU": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        }
      },
      "mt-MT": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jekk jogħġbok agħżel kumpanija"])}
        }
      },
      "sl-SI": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izberite podjetje"])}
        }
      },
      "tr-TR": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        }
      },
      "tr-CY": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        }
      },
      "uk-UA": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть компанію"])}
        }
      },
      "zh-CN": {
        "selectCompany": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择公司"])}
        }
      }
    }
  })
}
